// extracted by mini-css-extract-plugin
export var cls1 = "index-module--cls1--WQqm6";
export var cls2 = "index-module--cls2--d-j2y";